import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import axios from "axios";

export default function FormSimulasi(params) {

    let history = useHistory()
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = (data, e) => {
        var url = "https://script.google.com/macros/s/AKfycbw07tiLA69n96Oyc2a8q-eAcxwfMsKRV4oDmkVlcAAp1SB8el0OrBqSG0RCzDnAcVzp5A/exec?";

        const params = new URLSearchParams({
            action: "simulasi",
            tarif_tdl: data.tarif_tdl,
            lama_kontrak: data.lama_kontrak,
            beban: data.beban_watt,
            luas: data.luas_penampang_atap,
        }).toString();

        axios.post(url + params)
            .then(res => {
                console.log(res.data.success);
                if (res.data.success != false) {
                    alert("Input Simulasi Berhasil");
                    history.push("/simulasi-penghematan")
                } else {
                    alert("Input Simulasi Gagal !");
                    reset()
                }
            })
            .catch(err => {
                console.log(err);
                alert("Message failed to send, please try again.");
            })
    }

    return (
        <div className="w-full flex justify-center  mb-56 mt-4">
            <form onSubmit={handleSubmit(onSubmit)} className="bg-white shadow-md w-full lg:w-1/2 rounded px-8 pt-6 pb-8 mb-4 justify-center">
                <div className="flex items-center justify-center">
                    <p className="font-bold text-2xl">Simulasi Penghematan</p>
                </div>
                <div className="mb-4 mt-10">
                    <label className="block text-gray-700 text-sm mb-2">
                        Tarif TDL
                    </label>
                    <input {...register("tarif_tdl", { required: true })} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="masukkan nama lengkap" />
                    {errors.tarif_tdl && <p className="mt-4 text-red-500 text-sm">This field is required</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm mb-2">
                        Lama Kontrak
                    </label>
                    <input {...register("lama_kontrak", { required: true })} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="password" type="text" placeholder="masukkan email (opsional)" />
                    {errors.lama_kontrak && <p className="mt-4 text-red-500 text-sm">This field is required</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm mb-2">
                        Beban (watt)
                    </label>
                    <input {...register("beban_watt", { required: true })} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="password" type="text" placeholder="masukan no telepon" />
                    {errors.beban_watt && <p className="mt-4 text-red-500 text-sm">This field is required</p>}
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm mb-2">
                        Luas Penampang Atap
                    </label>
                    <input {...register("luas_penampang_atap", { required: true })} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="password" type="text" placeholder="masukkan calon client" />
                    {errors.luas_penampang_atap && <p className="mt-4 text-red-500 text-sm">This field is required</p>}
                </div>
                <div className="flex items-center justify-center mt-8">
                    <button className="w-1/2 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
                        Submit
                        {/* {loading && (
                            <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                            />
                        )}
                        {loading && <span>Loading Data from Server</span>}
                        {!loading && <span>Fetch Data from Server</span>} */}
                    </button>
                </div>
            </form>
        </div>
    )
}